<div class="inner_scroll_navbar_container sticky-top">
  <nav class="navbar navbar-expand inner_scroll_navbar">
    <ul class="navbar-nav mt-2 mb-3">
      <ng-container *ngFor="let elem of piesPeriod; index as i;">
        <li class="nav-item">
          <button class="btn btn-sm" (click)="scrollToHierarchy('charts_' + i)">{{ piesPeriod[i][0].title }}</button>
        </li>
      </ng-container>
      <ng-container *ngFor="let elem of funnelsPeriod; index as i;">
        <li class="nav-item">
          <button class="btn btn-sm" (click)="scrollToHierarchy('charts_funnel_' + i)">{{ funnelsPeriod[i][0].title
            }}</button>
        </li>
      </ng-container>
    </ul>
  </nav>
</div>

<ng-container *ngFor="let elem of piesPeriod; index as i;">
  <div class="bg-primarylight py-4 px-2 px-md-5 mb-5 text-center" id="charts_{{i}}">
    <div class="row">
      <div class="col pt-2">
        <div class="statistics_chart_title">{{ piesPeriod[i][0].title }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <p class="mb-0"><strong>Periodo seleccionado</strong><button type="button" class="endtex-btn-help"
            data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="top"
            data-bs-content="Datos calculados sobre el periodo seleccionado de las fechas de recepción de citas (de la fecha de inicio a la fecha de fin incluidos)"><span
              class="visually-hidden">Ayuda</span></button></p>
        <div *ngIf="piesPeriod[i] && piesPeriod[i].length>0" id="piePeriod{{ piesPeriod[i][0].title }}"
          class="hgch-medium-label">
          <div class="loader position-relative">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <p class="mb-0"><strong>Acumulado año</strong><button type="button" class="endtex-btn-help"
            data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="top"
            data-bs-content="Datos calculados desde el 01/01 del año seleccionado al la fecha de fin del periodo seleccionado"><span
              class="visually-hidden">Ayuda</span></button></p>
        <div *ngIf="piesYear[i] && piesYear[i].length>0" id="pieYear{{ piesYear[i][0].title }}"
          class="hgch-medium-label">
          <div class="loader position-relative">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Agregar leyenda solo para el gráfico específico -->
    <div class="row" *ngIf="shouldShowLegend(piesPeriod[i][0].title)">
      <div *ngIf="shouldShowLegend(piesPeriod[i][0].title) != ''" class="col">
        <p class="mt-3 mb-0 text-muted small">{{shouldShowLegend(piesPeriod[i][0].title)}}</p>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngFor="let elem of funnelsPeriod; index as i;">
  <div class="bg-primarylight py-4 px-2 px-md-5 mb-5 text-center" id="charts_funnel_{{i}}">
    <div class="row">
      <div class="col pt-2">
        <div class="statistics_chart_title">{{ funnelsPeriod[i][0].title }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <p class="mb-0"><strong>Periodo seleccionado</strong><button type="button" class="endtex-btn-help"
            data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="top"
            data-bs-content="Datos calculados sobre el periodo seleccionado de las fechas de recepción de citas (de la fecha de inicio a la fecha de fin incluidos)"><span
              class="visually-hidden">Ayuda</span></button></p>
        <div *ngIf="funnelsPeriod[i] && funnelsPeriod[i].length>0" id="funnelPeriod{{ funnelsPeriod[i][0].title }}"
          class="hgch-medium-label">
          <div class="loader position-relative">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <p class="mb-0"><strong>Acumulado año</strong><button type="button" class="endtex-btn-help"
            data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="top"
            data-bs-content="Datos calculados desde el 01/01 del año seleccionado al la fecha de fin del periodo seleccionado"><span
              class="visually-hidden">Ayuda</span></button></p>
        <div *ngIf="funnelsPeriod[i] && funnelsYear[i].length>0" id="funnelYear{{ funnelsYear[i][0].title }}"
          class="hgch-medium-label">
          <div class="loader position-relative">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>